import Arrow from 'styles/icons/Arrow';
import ButtonWrapper from '../primitives/ButtonWrapper';
import FilledButton from 'primitives/Buttons/FilledButton';
import NoResultsFound from '../primitives/NoResultsFound';
import P from 'primitives/Typography/BodyCopy/P';
import PLAYED_FROM from 'modules/Analytics/constants/playedFrom';
import SearchSection from 'components/SearchSection';
import { STATION_TYPE } from 'constants/stationTypes';

export const matchesTopResult = (result, topResult) => {
  if (!result || !topResult) return false;

  // Checks if KEYWORDS top result is the same as currently filtered result
  if (topResult?.catalogId && result?.catalogId) {
    if (String(topResult.catalogId) === String(result.catalogId)) {
      return true;
    }
  }

  const topMatchValues = Object.values(topResult).sort();
  const currentValues = Object.values(result).sort();

  if (topMatchValues.length !== currentValues.length) return false;

  for (let i = 0; i < topMatchValues.length; i += 1) {
    if (topMatchValues[i] !== currentValues[i]) return false;
  }
  return true;
};

export const renderNewSearch = (
  props,
  state,
  filterType,
  setTrackingData,
  onShowMoreClick,
) => {
  const { customRadioEnabled, liveRadioEnabled, searchQuery, translate } =
    props;
  const { selected, showMoreVisible, result: results, resultCount } = state;
  const { bestMatch, nextPage } = results;

  let searchSections = [];
  let showMoreBtn;

  let { results: searchResults } = results;

  if (searchResults && resultCount) {
    if (bestMatch && filterType === '') {
      const bestMatchData =
        bestMatch.catalogType === STATION_TYPE.ALBUM ?
          {
            ...bestMatch,
            description: translate('Album{bulletSeparator}{artistName}', {
              artistName: bestMatch.artistName ?? 'Various Artists',
              bulletSeparator: <span>&nbsp;&bull;&nbsp;</span>,
            }),
          }
        : bestMatch;

      searchSections.push(
        <SearchSection
          bestMatch
          data={[bestMatchData]}
          key="tophit"
          playedFrom={PLAYED_FROM.SEARCH_RESULTS_MAIN_TOP_HIT}
          selected={selected}
          setTrackingData={setTrackingData}
          title="Top Result"
          translate={translate}
        />,
      );

      searchResults = searchResults.filter(
        value => !matchesTopResult(value, bestMatch),
      );
    }

    if (searchResults.length) {
      searchSections.push(
        <SearchSection
          bestMatch={false}
          data={searchResults}
          dataTest="newSearch-search-section"
          filter={filterType}
          key="results"
          keywords={searchQuery}
          playedFrom={
            filterType ?
              PLAYED_FROM.SEARCH_RESULTS_FILTERED
            : PLAYED_FROM.SEARCH_RESULTS_MAIN
          }
          playedFromFilter={filterType}
          selected={selected - 1}
          setTrackingData={setTrackingData}
          title="Search Results"
          translate={translate}
        />,
      );
    }

    if (nextPage) {
      searchSections.push(
        <ButtonWrapper key="showMore">
          <FilledButton
            aria-label={translate('Show More Results')}
            onClick={onShowMoreClick}
            styleType="cta"
          >
            {translate('Show More Results')}
          </FilledButton>
        </ButtonWrapper>,
      );
    }
  }

  let queryEmptyPrompt = '';
  if (customRadioEnabled) {
    queryEmptyPrompt = translate(
      'Search iHeart for artists, stations or podcasts.',
    );
  } else if (liveRadioEnabled) {
    queryEmptyPrompt = translate('Search iHeart for stations or podcasts.');
  } else {
    queryEmptyPrompt = translate('Search iHeart for podcasts.');
  }

  if (!searchSections.length && searchQuery !== '') {
    searchSections = (
      <NoResultsFound>
        <Arrow css={{ marginBottom: '2rem' }} />
        <p>
          {translate('There are no results for "{searchQuery}"', {
            searchQuery,
          })}
        </p>
        <P
          color={colors => colors.gray.medium}
          fontSize={size => size.xsmall}
          textAlign="center"
        >
          {translate('Check your spelling or try another search')}
        </P>
      </NoResultsFound>
    );
  } else if (!searchSections.length && searchQuery === '') {
    searchSections = (
      <NoResultsFound>
        <Arrow css={{ marginBottom: '2rem' }} />
        <p>{queryEmptyPrompt}</p>
      </NoResultsFound>
    );
  }

  return {
    searchSections,
    showMoreVisible,
    showMoreBtn,
  };
};
